import { useNotificationsStore } from '@/stores/notifications/notifications.store';

export default function newMessageAssignedConversation(): void {
  const notificationsStore = useNotificationsStore();

  notificationsStore.increaseNotificationsNumber();
}
